'use client'

import React from 'react'
import styles from './styles.module.scss'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export default function Footer() {
    const pathname = usePathname()

    if (pathname !== '/' && pathname !== '/promocoes')
        return <></>

    return (
        <footer className={styles.container}>
            <div className={styles.subContainer}>
                <small className='font-sm'>© Desenvolvido por <Link href={'https://consumer.com.br/menudino?AfiId=333'} target='_blank'>Consumer</Link></small>
            </div>
        </footer>
    )
}